import React, { ReactNode } from 'react';
import classNames from 'classnames';
import * as styles from './ModalBody.module.scss';
import { ModalHeading } from './ModalHeading';

type ModalBodyProps = {
  children: ReactNode;
  className?: string;
};

export const ModalBody = ({ children, className }: ModalBodyProps) => {
  return (
    <div className={classNames(className, styles.ModalBody)}>{children}</div>
  );
};

ModalBody.Heading = ModalHeading;
